var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 68,
    viewBox: "0 0 58 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-899 -2064)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18 51)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 68,
    rx: 4,
    transform: "translate(881 2013)",
    fill: "#eff1f5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(895.084 2018.902)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5,
    cy: 5.5,
    rx: 5,
    ry: 5.5,
    transform: "translate(9.916 4.098)",
    fill: "#d6d6e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.832,21.187v1.365a1.365,1.365,0,0,1-1.365,1.365H5.365A1.365,1.365,0,0,1,4,22.552V21.187A8.187,8.187,0,0,1,12.187,13h5.458A8.187,8.187,0,0,1,25.832,21.187Z",
    transform: "translate(0 3.281)",
    fill: "#d6d6e8"
  })), /*#__PURE__*/React.createElement("line", {
    x2: 45,
    transform: "translate(888.5 2056.5)",
    fill: "none",
    stroke: "#d6d6e8",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 45,
    transform: "translate(888.5 2062.5)",
    fill: "none",
    stroke: "#d6d6e8",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 24,
    transform: "translate(899.5 2068.5)",
    fill: "none",
    stroke: "#d6d6e8",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAccount);
export default __webpack_public_path__ + "static/media/no-account.6f177cd77fcb55db4c1e1e0f5a29f980.svg";
export { ForwardRef as ReactComponent };